module.exports = __webpack_public_path__ + "media/images/flags/64/United-States-9453b078b00b9f12517652e969ed44b1.png";